var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"value":true,"color":_vm.type.toLowerCase(),"icon":_vm.icon,"dismissible":true,"transition":"fade-transition"}},[_vm._v(" "+_vm._s(this.alertText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }